"use strict";
// invariants for the entity goes here
module.exports = entity => {
    if (entity.customerSubUnitId === null && entity.supplierCustomerId === null) {
        throw new Error('A shop user needs an id to a customer');
    }
    return entity;
};
